import styled from 'styled-components';
import { Colors } from '@/common/colors/colors';

export const Icon = styled.i`
	font-size: 26px;
	cursor: pointer;
	color: ${Colors.darkBlue};
`;
